import React, { useState, useEffect, useContext } from 'react';
import { GlobalContext } from 'context/userContext';
import { DrawerHeader } from '@components/drawer-header';

import { Grid, Paper, Box, Typography, TextField, Button, IconButton, List, ListItem, ListItemButton, ListItemText, Divider, Chip, useTheme, FormControlLabel, Checkbox } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MapIcon from '@mui/icons-material/Map';

import { AxiosInstanceLongTimeOut } from '@service/axios-instance';

import {
  MapContainer, TileLayer, Marker, Popup, Polyline, ImageOverlay,
  LayersControl, LayerGroup, useMap, Polygon, useMapEvents, CircleMarker, Tooltip
} from 'react-leaflet';

import L, { LatLngExpression, LatLngLiteral, LatLngBoundsExpression } from 'leaflet';
import "leaflet/dist/leaflet.css";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

/* -------------------- Tipos -------------------- */
type Position = { lat: number; lng: number; timestamp: string; };

type Area = {
  id: string;
  name: string;
  points: LatLngLiteral[];   // [{lat,lng}, ...]
  status: 'Entrando' | 'Saindo' | 'Entrando / Saindo' | 'Desabilitado';
  emails: string[];
  isMaintenanceArea?: boolean;
  isGpsReference?: boolean;
};

/* -------------------- Overlay de imagem (mantido do seu código) -------------------- */
const imageUrl = 'https://vitruvius.com.br/media/images/magazines/grid_12/ca3d_inst47-08.jpg';
const imageBounds: LatLngBoundsExpression = [
  [-23.5510, -46.6340],
  [-23.5500, -46.6320],
];

/* -------------------- Auxiliar: recentrar -------------------- */
const MapCenterChanger = ({ center }: { center: LatLngExpression }) => {
  const map = useMap();
  useEffect(() => { map.setView(center); }, [center, map]);
  return null;
};

function CacheMapState() {
  const map = useMapEvents({
    moveend: () => {
      const center = map.getCenter();
      const zoom = map.getZoom();
      localStorage.setItem('cachedMapState', JSON.stringify({ lat: center.lat, lng: center.lng, zoom }));
    }
  });
  return null;
}

/* -------------------- Captura de cliques para “desenhar” -------------------- */
function DrawingCapture({
  enabled,
  onAddPoint,
}: {
  enabled: boolean;
  onAddPoint: (p: LatLngLiteral) => void;
}) {
  useMapEvents({
    click(e) {
      if (!enabled) return;
      onAddPoint({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });
  return null;
}

/* ========================================================================== */
/*                                  PÁGINA                                    */
/* ========================================================================== */



export function CercaVirtual() {
  const { operation, equipament, startDate, endDate } = useContext(GlobalContext);

  // mapa (mantido)
  const [positions, setPositions] = useState<Position[]>([]);
  const [multiPolyline, setMultiPolyline] = useState<LatLngExpression[][]>([]);
  const [mapCenter, setMapCenter] = useState<LatLngExpression>(() => {
    try {
      const cached = localStorage.getItem('cachedMapState');
      if (cached) {
        const { lat, lng } = JSON.parse(cached);
        if (lat && lng) return [lat, lng];
      }
    } catch (e) {}
    return [-19.964473724365234, -44.112449645996094];
  });

  const [mapZoom, setMapZoom] = useState<number>(() => {
    try {
      const cached = localStorage.getItem('cachedMapState');
      if (cached) {
        const { zoom } = JSON.parse(cached);
        if (zoom) return zoom;
      }
    } catch (e) {}
    return 18;
  });

  // Áreas / Geofences
  const [areas, setAreas] = useState<Area[]>([]);
  const [selectedAreaId, setSelectedAreaId] = useState<string | null>(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [draftPoints, setDraftPoints] = useState<LatLngLiteral[]>([]);
  const [newAreaName, setNewAreaName] = useState<string>('');





  // helper to upsert a single geofence
  async function syncGeofences(operation: string | null | undefined, allAreas: Area[]) {
    const base = '/geofences/sync';
    const url = operation && operation !== '' ? `${base}?db=${operation}` : base;

    // Prepare payload
    const payload = {
      geofences: allAreas.map(a => ({
        id: a.id,
        name: a.name,
        points: a.points.map(p => ([p.lat, p.lng])),
        status: a.status,
        emails: a.emails.map(e => e.trim()).filter(Boolean),
        isMaintenanceArea: a.isMaintenanceArea || false,
        isGpsReference: a.isGpsReference || false,
      }))
    };

    return AxiosInstanceLongTimeOut.post(url, payload, { withCredentials: true });
  }


  /* -------------------- Mock/Load inicial (mantenha sua fetch real aqui) -------------------- */
  useEffect(() => {
    if (!operation) return;
    fetchAreasData();
    // fetchHeartbeatData(); // (mantido se quiser)
  }, [operation]);

  const fetchAreasData = async () => {

    const request = {};
    const tableName = "geofences"
    const config = { withCredentials: true };

    console.log("FETCHAREAS", tableName, operation);

    let requestURL = ""
    if (operation != "") requestURL = "/geofences/get_geofences" + "?db=" + operation
    else requestURL = "/geofences/get_geofences"

    console.log("requesting", requestURL)

    AxiosInstanceLongTimeOut.post(requestURL, request, config).then((response) => {
      console.log("areas======>>>>>", response.data)

      // map old active/inactive to new status if needed, or just use what came from backend
      // defaulting to 'Desabilitado' if missing
      const adapted = response.data.map((r: any) => ({
        ...r,
        points: (Array.isArray(r.points))
          ? r.points.map((p: any) => {
            // backend sends [lat, lng]
            if (Array.isArray(p)) return { lat: p[0], lng: p[1] };
            return p; // fallback if already object
          })
          : [],
        status: r.status || (r.active ? 'Entrando / Saindo' : 'Desabilitado'),
        emails: r.emails || [],
        isMaintenanceArea: r.isMaintenanceArea || false,
        isGpsReference: r.isGpsReference || false,
      }));
      setAreas(adapted);

    })
      .catch((error) => {
        console.log(error)
      })
  };

  /* -------------------- Ações Sidebar -------------------- */
  const handleCreateArea = () => {
    const id = `area_${Date.now()}`;
    const base: Area = {
      id,
      name: newAreaName || 'Nova área',
      points: [],
      status: 'Saindo',
      emails: [],
      isMaintenanceArea: false
    };
    setAreas(prev => [base, ...prev]);
    setSelectedAreaId(id);
    setIsDrawing(true);
    setDraftPoints([]);
    setNewAreaName('');
  };

  const handleSelectArea = (id: string) => {
    setSelectedAreaId(id);
    setIsDrawing(false);
    setDraftPoints([]);
  };

  const handleStatusChange = (id: string) => {
    const items: Area['status'][] = ['Entrando', 'Saindo', 'Entrando / Saindo', 'Desabilitado'];

    setAreas(prev => prev.map(a => {
      if (a.id !== id) return a;
      const currentIndex = items.indexOf(a.status);
      const nextIndex = (currentIndex + 1) % items.length;
      const newStatus = items[nextIndex];
      // update backend immediately? or just optimistic
      // REMOVED AUTO SAVE
      // if (a.points.length >= 3) {
      //   updateGeofence(operation ?? undefined, { ...a, status: newStatus }).catch(err => console.error(err));
      // }
      return { ...a, status: newStatus };
    }));
  };

  const handleEmailChange = (id: string, val: string) => {
    // split by newline
    // We do NOT filter(Boolean) here, so the user can type a newline (which creates an empty string at the end)
    // The backend or onBlur logic should handle cleanup if needed, but keeping it in state allows the UI to show the new line.

    // Also handle ; just in case they paste it or try to use it, replacing with newline
    const normalized = val.replace(/;/g, '\n');
    const parts = normalized.split('\n');

    setAreas(prev => prev.map(a => {
      if (a.id !== id) return a;
      return { ...a, emails: parts };
    }));
  };

  const handleMaintenanceAreaChange = (id: string, isMaintenanceArea: boolean) => {
    setAreas(prev => prev.map(a => {
      if (a.id !== id) return a;
      return { ...a, isMaintenanceArea };
    }));
  };

  // Save on blur using the current DOM value to ensure we don't save stale state
  const handleEmailBlur = (id: string, currentValue: string) => {
    // REMOVED AUTO SAVE
    // Just update local state which is already done by handleEmailChange (actually handleEmailChange updates state)
    // We don't need to do anything here if we are manual saving. 
    // But wait, handleEmailChange updates state. So the state is already fresh.
    // We can just omit this function usage or leave it empty.
  };


  const handleDeleteArea = async (id: string) => {
    // optimistic UI - just remove from list and add to pending deletes
    setAreas(prev => prev.filter(a => a.id !== id));

    if (selectedAreaId === id) {
      setSelectedAreaId(null);
      setIsDrawing(false);
      setDraftPoints([]);
    }
    // REMOVED AUTO DELETE CALL
  };

  const startDrawingForSelected = () => {
    if (!selectedAreaId) return;
    setIsDrawing(true);
    setDraftPoints([]);
  };

  const cancelDrawing = () => {
    setIsDrawing(false);
    setDraftPoints([]);
  };


  const finishDrawing = async () => {
    if (!selectedAreaId) return;
    if (draftPoints.length < 3) { alert('Adicione pelo menos 3 pontos.'); return; }

    const before = areas;
    const next = areas.map(a =>
      a.id === selectedAreaId ? { ...a, points: draftPoints.slice(), status: a.status === 'Desabilitado' ? 'Entrando / Saindo' : a.status } : a
    );

    setAreas(next);
    setIsDrawing(false);
    setDraftPoints([]);

    setAreas(next);
    setIsDrawing(false);
    setDraftPoints([]);

    // REMOVED AUTO SAVE
    // try {
    //   const toSave = next.find(a => a.id === selectedAreaId)!;
    //   await updateGeofence(operation ?? undefined, toSave); // <- fix types
    // } catch (e) {
    //   console.error('Falha ao salvar a área', e);
    //   alert('Erro ao salvar a área. Suas alterações foram revertidas.');
    //   setAreas(before); // rollback
    // }
  };

  const handleSaveAll = async () => {
    try {
      await syncGeofences(operation ?? undefined, areas);
      alert('Dados salvos com sucesso!');
      fetchAreasData(); // Refresh to be sure
    } catch (e) {
      console.error(e);
      alert('Erro ao salvar dados.');
    }
  };



  /* -------------------- Captura clique no mapa para desenhar -------------------- */
  const onAddDraftPoint = (p: LatLngLiteral) => setDraftPoints(prev => [...prev, p]);

  /* -------------------- Dados de mapa (mantidos do seu fetch) -------------------- */
  const request_dict = { start_date: startDate, end_date: endDate, match_filters_dict: { id: equipament } };
  const request_config = { withCredentials: true };

  // ... se quiser manter seu fetchHeartbeatData, pode colar aqui sem mudanças

  /* -------------------- Render -------------------- */
  const selectedArea = areas.find(a => a.id === selectedAreaId) || null;

  const theme = useTheme();

  return (
    <DrawerHeader title={"Cerca Virtual - Configurador de Áreas"}>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Paper
            elevation={2}
            sx={{
              p: { xs: 2.5, md: 3 },
              bgcolor: 'background.paper',
              borderLeft: `6px solid ${theme.palette.primary.main}`,
              borderRadius: 2,
              mb: 1
            }}
          >
            <Box>
              <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1.5, fontWeight: 600 }}>
                MONITORAMENTO ESPACIAL
              </Typography>
              <Typography variant="h4" fontFamily="Saira" fontWeight={900} color="text.primary">Configuração de Cerca Virtual</Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                Desenhe polígonos no mapa para delimitar áreas geográficas de interesse. Configure alertas automáticos por e-mail para notificações de entradas e saídas de equipamentos em zonas restritas.
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0, ml: 0 }}>
        {/* -------------------- Sidebar - Lista de Áreas -------------------- */}
        <Grid item xs={12} md={4} lg={3}>
          <Paper elevation={5} style={{ padding: 16 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Typography variant="h6" sx={{ mb: 0 }}>Áreas</Typography>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handleSaveAll}
              >
                Salvar Alterações
              </Button>
            </Box>

            <Box display="flex" gap={1} mb={2}>
              <TextField
                size="small"
                fullWidth
                label="Nome da nova área"
                value={newAreaName}
                onChange={(e) => setNewAreaName(e.target.value)}
              />
              <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreateArea}>
                Criar
              </Button>
            </Box>

            <List dense>
              {areas.map(a => (
                <React.Fragment key={a.id}>

                  <ListItem
                    disablePadding
                    sx={{ flexDirection: 'column', alignItems: 'stretch', borderBottom: '1px solid #eee' }}
                  >
                    {/* Entire Card Clickable via Box wrapper */}
                    <Box
                      onClick={() => handleSelectArea(a.id)}
                      sx={{
                        width: '100%',
                        cursor: 'pointer',
                        bgcolor: selectedAreaId === a.id ? 'action.selected' : 'transparent',
                        '&:hover': { bgcolor: 'action.hover' },
                        pb: 1
                      }}
                    >
                      {/* Header Row */}
                      <Box display="flex" justifyContent="space-between" alignItems="flex-start" pt={2} pb={1} pl={2} pr={1}>
                        <ListItemText
                          primary={a.name}
                          secondary={a.points.length ? `${a.points.length} ponto(s)` : 'Sem pontos'}
                          sx={{ m: 0, flexGrow: 1 }}
                        />

                        <Box
                          display="flex"
                          alignItems="center"
                          gap={0.5}
                          ml={2}
                          onClick={(e) => e.stopPropagation()} // Prevent selection when clicking actions
                        >
                          <Chip
                            size="small"
                            label={a.status}
                            color={
                              a.status === 'Entrando' ? 'success' :
                                a.status === 'Saindo' ? 'warning' :
                                  a.status === 'Entrando / Saindo' ? 'info' : 'default'
                            }
                            onClick={(e) => { e.stopPropagation(); handleStatusChange(a.id); }}
                            sx={{ cursor: 'pointer', minWidth: 80 }}
                          />
                          <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleDeleteArea(a.id); }}>
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>

                      {/* Email Input */}
                      <Box px={2} pb={1}>
                        <TextField
                          label="Emails (um por linha)"
                          fullWidth
                          size="small"
                          variant="outlined"
                          multiline
                          minRows={2}
                          maxRows={5}
                          value={a.emails ? a.emails.join('\n') : ''}
                          onChange={(e) => handleEmailChange(a.id, e.target.value)}
                          // onBlur removed - manual save only
                          placeholder="email@exemplo.com"
                        // No propagation stop here; clicking input ALSO selects the area, which is good UX
                        />
                      </Box>
                      <Box px={2} pb={1} onClick={(e) => e.stopPropagation()}>
                        <FormControlLabel
                          control={
                            <Checkbox 
                              size="small" 
                              checked={!!a.isMaintenanceArea} 
                              onChange={(e) => handleMaintenanceAreaChange(a.id, e.target.checked)} 
                            />
                          }
                          label={<Typography variant="body2" color="text.secondary">Área de Manutenção</Typography>}
                        />
                        <FormControlLabel
                          control={<Checkbox size="small" checked={!!a.isGpsReference}
                            onChange={(e) => setAreas(prev => prev.map(area => area.id === a.id ? { ...area, isGpsReference: e.target.checked } : area))} />}
                          label={<Typography variant="body2">Área habitual de GPS</Typography>}
                        />
                        {a.isGpsReference && <Typography variant="caption" display="block" color="text.secondary">
                          Posições externas são aceitas após 3 leituras em até 1 km da primeira leitura, durante pelo menos 60 segundos. Não bloqueia deslocamentos reais. Salve as alterações para aplicar.
                        </Typography>}

                      </Box>
                    </Box>
                  </ListItem>


                  <Divider component="li" />


                </React.Fragment>
              ))}
            </List>

            {/* Controles de desenho para a área selecionada */}
            <Box mt={2}>
              <Typography variant="subtitle2" color="text.secondary">
                {selectedArea ? `Selecionada: ${selectedArea.name}` : 'Nenhuma área selecionada'}
              </Typography>

              <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<MapIcon />}
                  disabled={!selectedArea}
                  onClick={startDrawingForSelected}
                >
                  Desenhar
                </Button>

                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  startIcon={<CheckIcon />}
                  disabled={!isDrawing || draftPoints.length < 3}
                  onClick={finishDrawing}
                >
                  Concluir
                </Button>

                <Button
                  variant="text"
                  color="inherit"
                  size="small"
                  startIcon={<CloseIcon />}
                  disabled={!isDrawing}
                  onClick={cancelDrawing}
                >
                  Cancelar
                </Button>
              </Box>

              {isDrawing && (
                <Typography variant="caption" color="text.secondary" display="block" mt={1}>
                  Modo desenho ativo: clique no mapa para adicionar vértices.
                </Typography>
              )}
            </Box>
          </Paper>
        </Grid>

        {/* -------------------- Mapa -------------------- */}
        <Grid item xs={12} md={8} lg={9}>
          <Paper elevation={5} style={{ padding: "10px 20px 10px 20px", width: "100%", height: "100%" }}>
            <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: '600px', width: '100%' }}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <MapCenterChanger center={mapCenter} />
              <CacheMapState />

              {/* Captura de cliques quando desenhando */}
              <DrawingCapture enabled={isDrawing} onAddPoint={onAddDraftPoint} />

              <LayersControl position="topright">
                <LayersControl.Overlay checked name="Áreas">
                  <LayerGroup>
                    {areas.filter(a => a.status !== 'Desabilitado' && a.points.length >= 3).map(a => (
                      <Polygon
                        key={a.id}
                        positions={a.points}
                        pathOptions={{ color: selectedAreaId === a.id ? 'red' : 'blue', weight: 2, fillOpacity: 0.15 }}
                      >
                        <Popup>
                          <b>{a.name}</b><br />
                          {a.points.length} ponto(s)
                        </Popup>
                      </Polygon>
                    ))}

                    {/* rascunho enquanto desenha */}
                    {isDrawing && draftPoints.length >= 2 && (
                      <Polyline positions={draftPoints} pathOptions={{ color: 'orange', dashArray: '6 6' }} />
                    )}

                    {/* marcadores de feedback por clique */}
                    {isDrawing && draftPoints.map((p, i) => (
                      <CircleMarker
                        key={`draft-pt-${i}`}
                        center={p}
                        radius={5}
                        pathOptions={{ color: 'orange', fillOpacity: 0.9, weight: 2 }}
                      >
                        <Tooltip permanent direction="top" offset={[0, -6]}>
                          {i + 1}
                        </Tooltip>
                      </CircleMarker>
                    ))}
                  </LayerGroup>
                </LayersControl.Overlay>

              </LayersControl>
            </MapContainer>
          </Paper>
        </Grid>
      </Grid>
    </DrawerHeader>
  );
}
